import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Dropdown,
  Accordion,
  InputGroup,
} from "react-bootstrap";
import {
  CalendarIcon,
  DeleteIcon,
  EditIcon,
  GearIcon,
  MoneyDollarIcon,
  PrintIcon,
} from "./Icons";
import "./../assets/scss/reports/cashbook.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import DateRangePicker from "./utils/DateRangePicker";
import CachedIcon from "mdi-react/CachedIcon";

import {
  FilterTwoIcon,
  SummaryChartIconUp,
  SummaryChartIconDown,
  SummaryCloseIcon,
} from "./Icons";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon";
import { reportActions } from "./../utils/reactQueryActions";
import useDebounce, {
  useBackendUrl,
  useCurrencies,
  useEffectOnce,
  useIsAdmin,
  useIsCashier,
  useQueryParams,
  useScrollTop,
} from "./../utils/hooks";
import queryString from "query-string";
import { services } from "./../config";
import { useMutation, useQuery } from "react-query";
import currency from "currency.js";
import { format, parse } from "date-fns";
import ReactPaginate from "react-paginate";
import {
  convertToBaseCurrency,
  paginationOptions,
  scrollToTop,
} from "./../utils/helpers";
import RsDateRangePicker from "./utils/RsDateRangePicker";
import { useAuth } from "./../hooks/useAuth";
import PageHeader from "./PageHeader";
import { useFormik } from "formik";
import * as yup from "yup";
import Select from "react-select";
import CurrencyCustomInput from "./utils/CurrencyCustomInput";
import { toast } from "react-toastify";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { isEmpty } from "lodash";
import LoginDialog from "./LoginDialog";
import ConfirmDialog from "./ConfirmDialogue";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { UnAuthorized } from "./utils/UnAuthorized";
import BankIcon from "mdi-react/BankIcon";
import { fetchActionsUtil } from "./../utils/helpers";
import ModalLoader from "./utils/ModalLoader";
import { useResolveRootRoles } from "./../utils/hooks";
import { useStoreState } from "easy-peasy";
import CogSyncOutlineIcon from "mdi-react/CogSyncOutlineIcon";
import { Popover } from "react-tiny-popover";
import ExpensesSelector from "./utils/ExpensesSelector";
import Datetime from "react-datetime";
import PaymentGatewayModal from "./PaymentGateway";
import EyeOutlineIcon from "mdi-react/EyeOutlineIcon";
import { Link } from "react-router-dom";

const initialValues = {
  AccountID: "",
  BankName: "",
  Branch: "",
  AccountOfficer: "",
  AccountNo: "",
  openingBalance: 0,
  buisinessBranch: "HQ",
  createSubAccountForAtc: false,
  Swift_code: "",
  Swift_bic: "",
  Routing_no: "",
  AccountName: "",

  //---------------------------------------------------------
  bankSortCodeNaira: "",
  bankSortCodeInternational: "",
  bankSwiftCodeInternational: "",
  swiftAddress: "",
  bankIban: "",
  abaNumber: "",
  intermediaryBank: "",
  correspondingBank: "",
  correspondingBankAccountNumber: "",
  currency: "",

  openingAccountID: "300",
  openingAccountDescription: "Opening Balance Equity",
  openingAccountType: "OWNER'S EQUITY",
  openingAccountAmount: 0,
  Date_Log_Opened: new Date(),
};

const schema = yup.object().shape({
  /*  AccountID: yup
  .number()
  .required("required")
  .moreThan(1000).lessThan(1999), */
  BankName: yup.string().required(),
  currency: yup.string().required(),
  // AccountNo: yup.string().required(),
});

function CreateBanksModal({
  showCreateBanksModal,
  setShowCreateBanksModal,
  refetch,
}) {
  const backendUrl = useBackendUrl();
  const { deploymentCurrencies: currenciesOptions } = useCurrencies();
  const generalSettings = useStoreState(state => state.generalSettings);

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      conversionAmount: generalSettings.dollarInBaseCurrency,
    },
    validationSchema: schema,
    onSubmit: async values => {
      //console.log(values, values.AccountID, isEmpty(values.AccountID));

      // if (!values.createSubAccountForAtc) {
      if (!values.AccountID) {
        formik.setFieldError("AccountID", "Enter GL Number");
        return toast.error("Enter GL Number");
      }
      if (Number(values.AccountID) < 1000 || Number(values.AccountID) > 1999) {
        return formik.setFieldError(
          "AccountID",
          `Enter a number between 1000 and 1999`
        );
      }
      // }

      if (values.createSubAccountForAtc) {
        // validate needed data
        if (!values.AccountNo) {
          formik.setFieldError("AccountNo", "Enter Bank Account Number");
          return toast.error("Enter Bank Account Number");
        }
      }

      createBanksMutation.mutate({ ...values });
    },
  });

  const fetchAccountId = async queryParams => {
    // await waitFor(5000);

    let response = await fetch(
      `${backendUrl}/api/accounts/generate-account-id`,
      {
        method: "POST",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          num1: 1000,
          num2: 1999,
        }),
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { id } = await response.json();
    let data = { id };
    return data;
  };

  const fetchGenerateAccountId = useQuery(
    ["GENERATE_ACCOUNT_ID"],
    () => fetchAccountId(),
    {
      onSuccess: data => {
        formik.setFieldValue("AccountID", data.id);
      },
      onError: ({ message = "" }) => {
        toast.error(`${message}: check your connection`);
      },
    }
  );

  const createBanks = async payload => {
    let dataToConvert = {
      openingBalance: payload.openingBalance,
      currencyCode: payload.currencyCode,
      conversionAmount: payload.conversionAmount,
    };

    if (
      dataToConvert.currencyCode &&
      dataToConvert.currencyCode !== generalSettings?.prevailingCurrency
    ) {
      dataToConvert = convertToBaseCurrency({
        data: dataToConvert,
        conversionAmount: dataToConvert.conversionAmount,
      });
    }

    payload = { ...payload, ...dataToConvert };

    let response = await fetch(`${backendUrl}/api/banks/create`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const createBanksMutation = useMutation(payload => createBanks(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      formik.resetForm();
      refetch();
      setShowCreateBanksModal(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      el => el.cc === formik.values.currency
    );
    return foundCurrency ? foundCurrency.symbol : "₦";
  }, [formik.values.currency]);

  // GA ===============================================================
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const handleSelectedAccount = account => {
    console.log(account);
    formik.setFieldValue("openingAccountID", account?.AccountID);
    formik.setFieldValue("openingAccountDescription", account?.Description);
    formik.setFieldValue("openingAccountType", account?.Type);
    setShowJournalPopover(false);
  };
  // ===================================================================

  return (
    <Modal
      show={showCreateBanksModal}
      onHide={() => setShowCreateBanksModal(false)}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h5">Create a Bank</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>GL Account Number</Form.Label>
            <InputGroup
              isInvalid={formik.touched.AccountID && !!formik.errors.AccountID}
            >
              <Form.Control
                name="AccountID"
                placeholder="GL Account Number"
                type="number"
                value={formik.values.AccountID}
                onChange={formik.handleChange}
                isInvalid={
                  formik.touched.AccountID && !!formik.errors.AccountID
                }
                disabled={fetchGenerateAccountId?.isFetching}
              />
              <InputGroup.Text
                title="Generate"
                onClick={() => fetchGenerateAccountId.refetch()}
              >
                <CogSyncOutlineIcon />
              </InputGroup.Text>
            </InputGroup>
            <Form.Control.Feedback type="invalid">
              {formik.errors.AccountID}
            </Form.Control.Feedback>

            <div className="text-muted mt-2">
              <p>Number Range: 1000 - 1999</p>
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account Name</Form.Label>
            <Form.Control
              name="AccountName"
              placeholder="Enter Account Name"
              value={formik.values.AccountName}
              onChange={formik.handleChange}
              isInvalid={
                formik.touched.AccountName && !!formik.errors.AccountName
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.AccountName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              name="BankName"
              placeholder="Enter Bank Name"
              value={formik.values.BankName}
              onChange={formik.handleChange}
              isInvalid={formik.touched.BankName && !!formik.errors.BankName}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.BankName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Branch</Form.Label>
            <Form.Control
              name="Branch"
              placeholder="Enter Branch"
              value={formik.values.Branch}
              onChange={formik.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account Officer</Form.Label>
            <Form.Control
              name="AccountOfficer"
              placeholder="Enter AccountOfficer"
              value={formik.values.AccountOfficer}
              onChange={formik.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Bank Account Number</Form.Label>
            <Form.Control
              name="AccountNo"
              placeholder="Enter AccountNo"
              value={formik.values.AccountNo}
              onChange={formik.handleChange}
              isInvalid={formik.touched.AccountNo && !!formik.errors.AccountNo}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.AccountNo}
            </Form.Control.Feedback>
          </Form.Group>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Swift Code</Form.Label>
                <Form.Control
                  name="Swift_code"
                  placeholder="Enter Swift Code"
                  value={formik.values.Swift_code}
                  onChange={formik.handleChange}
                  isInvalid={
                    formik.touched.Swift_code && !!formik.errors.Swift_code
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.Swift_code}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>{" "}
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Swift Bic</Form.Label>
                <Form.Control
                  name="Swift_bic"
                  placeholder="Enter Swift Bic"
                  value={formik.values.Swift_bic}
                  onChange={formik.handleChange}
                  isInvalid={
                    formik.touched.Swift_bic && !!formik.errors.Swift_bic
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.Swift_bic}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>{" "}
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Routing No</Form.Label>
            <Form.Control
              name="Routing_no"
              placeholder="Enter Routing No"
              value={formik.values.Routing_no}
              onChange={formik.handleChange}
              isInvalid={
                formik.touched.Routing_no && !!formik.errors.Routing_no
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.Routing_no}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Currency</Form.Label>
            <Select
              classNamePrefix="form-select"
              placeholder="Select Currency"
              isSearchable={false}
              options={currenciesOptions}
              value={currenciesOptions.find(
                el => el.value === formik.values.currency
              )}
              onChange={({ value }) => {
                formik.setFieldValue("currency", value);
                formik.setFieldValue("currencyCode", value);
              }}
            />
            {formik.touched.currency && !!formik.errors.currency ? (
              <span className="text-danger mt-2">{formik.errors.currency}</span>
            ) : null}
          </Form.Group>
          <hr />
          {formik.values.currency &&
          formik.values.currency !== generalSettings?.prevailingCurrency ? (
            <Form.Group className="mb-3 pb-1">
              <Form.Label>Exchange Rate</Form.Label>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Select
                    classNamePrefix="form-select"
                    placeholder="Select Currency"
                    isSearchable={false}
                    options={currenciesOptions}
                    value={currenciesOptions.find(
                      el => el.value === formik.values.currencyCode
                    )}
                    onChange={selected =>
                      formik.setFieldValue("currencyCode", selected.value)
                    }
                    isDisabled
                  />
                </Form.Group>

                <Form.Group>
                  <CurrencyCustomInput
                    currencySymbol={"Ex. Rate"}
                    name="conversionAmount"
                    value={formik.values.conversionAmount}
                    onValueChange={(value, name) => {
                      formik.setFieldValue(name, value);
                    }}
                    placeholder="0.00"
                  />
                </Form.Group>
              </div>{" "}
            </Form.Group>
          ) : null}
          <Form.Group className="mb-3">
            <Form.Label>Opening Balance</Form.Label>
            <CurrencyCustomInput
              currencySymbol={currencySymbol}
              name="openingBalance"
              placeholder="Enter Opening Balance"
              value={formik.values.openingBalance}
              onValueChange={(value, name) => {
                formik.setFieldValue(name, value);
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account</Form.Label>
            <InputGroup hasValidation>
              <Form.Control
                placeholder="Select Account"
                value={`${formik.values?.openingAccountID || ""} / ${formik
                  .values?.openingAccountDescription || ""} / ${formik.values
                  ?.openingAccountType || ""}`}
                onChange={() => {}}
                readOnly
              />

              <Popover
                isOpen={showJournalPopover}
                onClickOutside={() => setShowJournalPopover(false)}
                content={() => (
                  <ExpensesSelector
                    handleSelectedExpense={handleSelectedAccount}
                    usage={"chart of accounts"}
                    onHide={() => setShowJournalPopover(false)}
                    Type="OWNER'S EQUITY"
                  />
                )}
                position="bottom"
              >
                <InputGroup.Text onClick={() => setShowJournalPopover(true)}>
                  <MagnifyIcon />
                </InputGroup.Text>
              </Popover>
            </InputGroup>
          </Form.Group>
          <Form.Group className="col-6 mb-3 pb-2">
            <Form.Label className="mb-1">As At</Form.Label>
            <Datetime
              dateFormat="MMM DD, YYYY"
              timeFormat={false}
              closeOnSelect={true}
              closeOnClickOutside={true}
              name="Date_Log_Opened"
              inputProps={{
                className: `date-input form-control ${
                  formik.touched.Date_Log_Opened &&
                  !!formik.errors.Date_Log_Opened
                    ? "is-invalid"
                    : ""
                }`,
                placeholder: "Select date",
                readOnly: true,
              }}
              value={formik.values.Date_Log_Opened}
              onChange={date => {
                formik.setFieldValue("Date_Log_Opened", date, true);
              }}
              onBlur={() => formik.setFieldTouched("Date_Log_Opened", true)}
            />
            {formik.touched.Date_Log_Opened &&
            !!formik.errors.Date_Log_Opened ? (
              <span className="custom-invalid-feedback">
                {formik.errors.Date_Log_Opened}
              </span>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3 d-none">
            <Form.Label>Business Branch</Form.Label>
            <Form.Control defaultValue="HQ" readOnly disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
              label="Create Sub vendor account"
              inline
              type={"checkbox"}
              checked={formik.values.createSubAccountForAtc}
              onChange={e =>
                formik.setFieldValue("createSubAccountForAtc", e.target.checked)
              }
            />
          </Form.Group>
          <hr />
          <Accordion className="mb-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Show more</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Bank Sort Code ({generalSettings?.prevailingCurrency})
                      </Form.Label>
                      <Form.Control
                        name="bankSortCodeNaira"
                        placeholder={`Enter Bank Sort Code (${
                          generalSettings?.prevailingCurrency
                        })`}
                        value={formik.values.bankSortCodeNaira}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Sort Code (International)</Form.Label>
                      <Form.Control
                        name="bankSortCodeInternational"
                        placeholder="Enter Bank Sort Code (International)"
                        value={formik.values.bankSortCodeInternational}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>{" "}
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Swift Code (International)</Form.Label>
                      <Form.Control
                        name="bankSwiftCodeInternational"
                        placeholder="Enter Bank Swift Code (International)"
                        value={formik.values.bankSwiftCodeInternational}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Swift Address</Form.Label>
                      <Form.Control
                        name="swiftAddress"
                        placeholder="Enter Swift Address"
                        value={formik.values.swiftAddress}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank IBAN</Form.Label>
                      <Form.Control
                        name="bankIban"
                        placeholder="Enter Bank IBAN"
                        value={formik.values.bankIban}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>ABA Number</Form.Label>
                      <Form.Control
                        name="abaNumber"
                        placeholder="Enter ABA Number"
                        value={formik.values.abaNumber}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Intermediary Bank</Form.Label>
                      <Form.Control
                        name="intermediaryBank"
                        placeholder="Enter Intermediary Bank"
                        value={formik.values.intermediaryBank}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Corresponding Bank</Form.Label>
                      <Form.Control
                        name="correspondingBank"
                        placeholder="Enter Corresponding  Bank"
                        value={formik.values.correspondingBank}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>{" "}
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Corresponding Bank Account Number</Form.Label>
                      <Form.Control
                        name="correspondingBankAccountNumber"
                        placeholder="Enter Corresponding  Bank  Account Number"
                        value={formik.values.correspondingBankAccountNumber}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Button
            disabled={createBanksMutation.isLoading}
            variant="primary"
            className="w-100 p-2"
            type="submit"
          >
            {createBanksMutation.isLoading ? "Please wait…" : "Create Now"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default function Banks() {
  const { backendUrl, token } = useAuth();
  const isAdmin = useIsAdmin();
  const isCashier = useIsCashier();
  const [showCreateBanksModal, setShowCreateBanksModal] = useState(false);
  const [showEditBanksModal, setShowEditBanksModal] = useState(false);
  const [
    selectedBankToSetupPaymentGate,
    handleSelectedBankToSetupPaymentGate,
  ] = useState();
  const [selectedBank, setSelectedBank] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { isPrivileged } = useResolveRootRoles();
  const generalSettings = useStoreState(state => state.generalSettings);
  useScrollTop();
  const initialFilterParams = { q: "", page: 1, limit: 40, withBalance: true };
  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const getBanks = async debouncedqueryParams => {
    let response = await fetch(
      `${backendUrl}/api/banks?${queryString.stringify(debouncedqueryParams)}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };

  const { data = { banks: [] }, refetch } = useQuery(
    ["GET_BUISINESS_BANKS", queryParams],
    () => getBanks(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteBanks = async payload => {
    let response = await fetch(`${backendUrl}/api/banks/delete-bank`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteBanksMutation = useMutation(payload => deleteBanks(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      refetch();
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const handleSearchQueryChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
      page: 1,
    });
  };

  const handleEdit = async bank => {
    setSelectedBank(null);
    if (await LoginDialog()) {
      setSelectedBank(bank);
      setShowEditBanksModal(true);
    }
  };

  const handleDelete = async bank => {
    if (await LoginDialog()) {
      if (
        await ConfirmDialog({
          type: "danger",
          title: "Delete Bank",
          description: "Are you sure you want to delete this Bank?",
        })
      ) {
        deleteBanksMutation.mutate({ ...bank });
      }
    }
  };

  const showOnInvoice = async ({ showOnInvoice, AccountNo }) => {
    setIsLoading(true);
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-invoice`,
      "POST",
      "",
      {
        showOnInvoice,
        AccountNo,
      }
    );
    refetch();
    toast.success(res.message);
    setIsLoading(false);
  };

  const showOnSalesInvoice = async ({ showOnSalesInvoice, AccountNo }) => {
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-salesinvoice`,
      "POST",
      "",
      {
        showOnSalesInvoice,
        AccountNo,
      }
    );
    refetch();
    toast.success(res.message);
  };

  const showOnOnlineStore = async ({ showOnOnlineStore, AccountNo }) => {
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-onlinestore`,
      "POST",
      "",
      {
        showOnOnlineStore,
        AccountNo,
      }
    );
    refetch();
    toast.success(res.message);
  };

  const showOnSubscriptionRenewal = async ({
    showOnSubscriptionRenewal,
    AccountNo,
  }) => {
    setIsLoading(true);
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-subscription-renewal`,
      "POST",
      "",
      {
        showOnSubscriptionRenewal,
        AccountNo,
      }
    );
    refetch();
    toast.success(res.message);
    setIsLoading(false);
  };
  const showOnAccountStatement = async ({
    showOnAccountStatement,
    AccountNo,
  }) => {
    setIsLoading(true);
    if (!AccountNo) return toast.error(`Add Account Number`);

    const res = await fetchActionsUtil(
      `${backendUrl}/api/banks/show-in-account-statement`,
      "POST",
      "",
      {
        showOnAccountStatement,
        AccountNo,
      }
    );
    refetch();
    toast.success(res.message);
    setIsLoading(false);
  };

  return (
    <>
      {isAdmin || isCashier || isPrivileged("Banking") ? (
        <main className="inner-page-outlet">
          <PageHeader
            name="Banks"
            description="All Business Banks"
            icon={<BankIcon />}
          />
          <main className="cash-book">
            <div className="content">
              <header>
                <div className="d-flex flex-wrap gap-3 col-md-4">
                  <div className="global-search-area w-75">
                    <MagnifyIcon />
                    <Form.Control
                      className=""
                      name="q"
                      value={filterParams.q}
                      onChange={e => handleSearchQueryChange(e)}
                      placeholder="Search..."
                    />
                  </div>
                  <Button
                    onClick={() => refetch()}
                    variant=""
                    className="bg-light-blue border-0 text-primary"
                  >
                    <CachedIcon />
                  </Button>
                </div>

                <div className="actions mr-5">
                  <Button
                    onClick={() => setShowCreateBanksModal(true)}
                    className="px-3"
                  >
                    + Create New Bank
                  </Button>
                </div>
              </header>

              <div className="px-md-4">
                <Table
                  responsive
                  borderless
                  striped
                  hover
                  className="product-table"
                >
                  <thead>
                    <tr>
                      <th />
                      <th>Bank Name</th>
                      <th>Account Name</th>
                      <th>Branch</th>
                      <th>Account Officer</th>
                      <th>Account No</th>
                      <th>Currency</th>
                      <th>Balance</th>
                      <th>Swift Code</th>
                      <th>Swift Bic</th>
                      <th>Routing No</th>
                      <th>
                        Bank Sort Code ({generalSettings?.prevailingCurrency})
                      </th>
                      <th>Bank Sort Code (International)</th>
                      <th>Bank Swift Code (International)</th>
                      <th>Swift Address</th>
                      <th>Bank IBAN</th>
                      <th>ABA Number</th>
                      <th>Intermediary Bank</th>
                      <th>Corresponding Bank</th>
                      <th>Corresponding Bank Account Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.banks.map((el, index) => (
                      <tr key={index}>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant=""
                              className="bg-white border-0"
                              bsPrefix="print more"
                            >
                              <DotsVerticalIcon />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              popperConfig={{
                                strategy: "fixed",
                              }}
                              renderOnMount
                              className="dropdown-with-icons"
                            >
                              <Dropdown.Item
                                as="button"
                                onClick={() => handleEdit(el)}
                              >
                                <EditIcon /> Edit
                              </Dropdown.Item>

                              {el.isSubAccountForAtc && (
                                <Dropdown.Item
                                  as={Link}
                                  to={`/vendor/upcoming-payments?page=1&limit=100&Trans_ID=&Vendor_ID=${
                                    el.AccountNo
                                  }&enableDateRange=true&Status=Outstanding&customerName=${
                                    el.BankName
                                  }`}
                                >
                                  <EyeOutlineIcon /> Sub Account
                                </Dropdown.Item>
                              )}

                              <Dropdown.Divider />

                              <div
                                className="d-flex p-cursor justify-content-between mb-3"
                                onClick={() =>
                                  showOnInvoice({
                                    showOnInvoice:
                                      el.showOnInvoice === "yes" ? "" : "yes",
                                    AccountNo: el.AccountNo,
                                  })
                                }
                              >
                                <p for="showinvoice" className="mx-2 p-cursor">
                                  Show on Proforma Invoice
                                </p>

                                <Form.Check
                                  className="mx-3 p-cursor"
                                  type="switch"
                                  id="showinvoice"
                                  checked={
                                    el.showOnInvoice === "yes" ? true : false
                                  }
                                />
                              </div>

                              <div
                                className="d-flex p-cursor justify-content-between mb-3"
                                onClick={() =>
                                  showOnSalesInvoice({
                                    showOnSalesInvoice:
                                      el.showOnSalesInvoice === "yes"
                                        ? ""
                                        : "yes",
                                    AccountNo: el.AccountNo,
                                  })
                                }
                              >
                                <p for="showinvoice" className="mx-2 p-cursor">
                                  Show on Sales Invoice
                                </p>

                                <Form.Check
                                  className="mx-3 p-cursor"
                                  type="switch"
                                  id="showOnSalesInvoice"
                                  checked={
                                    el.showOnSalesInvoice === "yes"
                                      ? true
                                      : false
                                  }
                                />
                              </div>

                              <div
                                className="d-flex p-cursor justify-content-between mb-3"
                                onClick={() =>
                                  showOnOnlineStore({
                                    showOnOnlineStore:
                                      el.showOnOnlineStore === "yes"
                                        ? ""
                                        : "yes",
                                    AccountNo: el.AccountNo,
                                  })
                                }
                              >
                                <p for="showinvoice" className="mx-2 p-cursor">
                                  Show on Online Store
                                </p>
                                <Form.Check
                                  className="mx-3 p-cursor"
                                  type="switch"
                                  id="showinvoice"
                                  checked={
                                    el.showOnOnlineStore === "yes"
                                      ? true
                                      : false
                                  }
                                />
                              </div>

                              <div
                                className="d-flex p-cursor justify-content-between mb-3"
                                onClick={() =>
                                  showOnAccountStatement({
                                    showOnAccountStatement:
                                      el.showOnAccountStatement === "yes"
                                        ? ""
                                        : "yes",
                                    AccountNo: el.AccountNo,
                                  })
                                }
                              >
                                <p for="showinvoice" className="mx-2 p-cursor">
                                  Show on Account Statement
                                </p>
                                <Form.Check
                                  className="mx-3 p-cursor"
                                  type="switch"
                                  id="showinvoice"
                                  checked={
                                    el.showOnAccountStatement === "yes"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <div
                                className="d-flex p-cursor justify-content-between mb-3"
                                onClick={() =>
                                  showOnSubscriptionRenewal({
                                    showOnSubscriptionRenewal:
                                      el?.showOnSubscriptionRenewal === "yes"
                                        ? ""
                                        : "yes",
                                    AccountNo: el.AccountNo,
                                  })
                                }
                              >
                                <p for="showinvoice" className="mx-2 p-cursor">
                                  Show on Subscription Renewal
                                </p>
                                <Form.Check
                                  className="mx-3 p-cursor"
                                  type="switch"
                                  id="showinvoice"
                                  checked={
                                    el?.showOnSubscriptionRenewal === "yes"
                                      ? true
                                      : false
                                  }
                                />
                              </div>

                              {/*  <Dropdown.Item
                                as="button"
                                onClick={() => handleSelectedBankToSetupPaymentGate(el)}
                              >
                                <MoneyDollarIcon /> Payment Gateway
                              </Dropdown.Item> */}

                              <Dropdown.Divider />

                              <Dropdown.Item
                                as="button"
                                className="text-danger"
                                onClick={() => handleDelete(el)}
                              >
                                <DeleteIcon /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>

                        <td>{el.BankName}</td>
                        <td>{el.AccountName || "..."}</td>
                        <td>{el.Branch || "..."}</td>
                        <td>{el.AccountOfficer || "..."}</td>
                        <td>{el.AccountNo}</td>
                        <td>{el.currency}</td>
                        <td>
                          {currency(el?.balance, {
                            symbol: "",
                          }).format()}
                        </td>

                        <td>{el.Swift_code || "..."}</td>
                        <td>{el.Swift_bic || "..."}</td>
                        <td>{el.Routing_no || "..."}</td>
                        <td>{el.bankSortCodeNaira || "..."}</td>
                        <td>{el.bankSortCodeInternational || "..."}</td>
                        <td>{el.bankSwiftCodeInternational || "..."}</td>
                        <td>{el.swiftAddress || "..."}</td>
                        <td>{el.bankIban || "..."}</td>
                        <td>{el.abaNumber || "..."}</td>
                        <td>{el.intermediaryBank || "..."}</td>
                        <td>{el.correspondingBank || "..."}</td>
                        <td>{el?.correspondingBankAccountNumber || "..."}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={e => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                    scrollToTop();
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </main>

          {showCreateBanksModal && (
            <CreateBanksModal
              showCreateBanksModal={showCreateBanksModal}
              setShowCreateBanksModal={setShowCreateBanksModal}
              refetch={refetch}
            />
          )}

          {!isEmpty(selectedBank) && (
            <EditBanksModal
              showEditBanksModal={showEditBanksModal}
              setShowEditBanksModal={setShowEditBanksModal}
              selectedBank={selectedBank}
              setSelectedBank={setSelectedBank}
              refetch={refetch}
            />
          )}
        </main>
      ) : (
        <UnAuthorized />
      )}

      {selectedBankToSetupPaymentGate && (
        <PaymentGatewayModal
          show={!!selectedBankToSetupPaymentGate}
          onHide={handleSelectedBankToSetupPaymentGate}
          selectedBank={selectedBankToSetupPaymentGate}
        />
      )}

      <ModalLoader show={isLoading} />
    </>
  );
}

function EditBanksModal({
  showEditBanksModal,
  setShowEditBanksModal,
  selectedBank = {},
  refetch,
  setSelectedBank,
}) {
  const backendUrl = useBackendUrl();
  const { deploymentCurrencies: currenciesOptions } = useCurrencies();
  const generalSettings = useStoreState(state => state.generalSettings);

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async values => {
      editBanksMutation.mutate({
        newBank: values,
        oldBank: selectedBank,
      });
    },
  });

  useEffectOnce(() => {
    formik.setValues({
      BankName: selectedBank.BankName,
      Branch: selectedBank.Branch,
      AccountOfficer: selectedBank.AccountOfficer,
      AccountNo: selectedBank.AccountNo,
      Swift_code: selectedBank.Swift_code,
      Swift_bic: selectedBank.Swift_bic,
      Routing_no: selectedBank.Routing_no,
      AccountName: selectedBank.AccountName,

      bankSortCodeNaira: selectedBank.bankSortCodeNaira,
      bankSortCodeInternational: selectedBank.bankSortCodeInternational,
      bankSwiftCodeInternational: selectedBank.bankSwiftCodeInternational,
      swiftAddress: selectedBank.swiftAddress,
      bankIban: selectedBank.bankIban,
      abaNumber: selectedBank.abaNumber,
      intermediaryBank: selectedBank.intermediaryBank,
      correspondingBank: selectedBank.correspondingBank,
      correspondingBankAccountNumber:
        selectedBank.correspondingBankAccountNumber,
      currency: selectedBank?.currency
        ? selectedBank?.currency
        : generalSettings?.prevailingCurrency,
    });
  });

  const editBanks = async payload => {
    let response = await fetch(`${backendUrl}/api/banks/update-bank`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const editBanksMutation = useMutation(payload => editBanks(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      formik.resetForm();
      refetch();
      setShowEditBanksModal(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      el => el.cc === formik.values.currency
    );
    return foundCurrency ? foundCurrency.symbol : "₦";
  }, [formik.values.currency]);

  return (
    <Modal
      show={showEditBanksModal}
      onHide={() => {
        setSelectedBank(null);
        setShowEditBanksModal(false);
      }}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h5">Edit Bank</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Account Name</Form.Label>
            <Form.Control
              name="AccountName"
              placeholder="Enter Account Name"
              value={formik.values.AccountName}
              onChange={formik.handleChange}
              isInvalid={
                formik.touched.AccountName && !!formik.errors.AccountName
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.AccountName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              name="BankName"
              placeholder="Enter Bank Name"
              value={formik.values.BankName}
              onChange={formik.handleChange}
              isInvalid={formik.touched.BankName && !!formik.errors.BankName}
              readOnly
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.BankName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Branch</Form.Label>
            <Form.Control
              name="Branch"
              placeholder="Enter Branch"
              value={formik.values.Branch}
              onChange={formik.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account Officer</Form.Label>
            <Form.Control
              name="AccountOfficer"
              placeholder="Enter AccountOfficer"
              value={formik.values.AccountOfficer}
              onChange={formik.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Bank Account Number</Form.Label>
            <Form.Control
              name="AccountNo"
              placeholder="Enter AccountNo"
              value={formik.values.AccountNo}
              onChange={formik.handleChange}
              isInvalid={formik.touched.AccountNo && !!formik.errors.AccountNo}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.AccountNo}
            </Form.Control.Feedback>
          </Form.Group>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Swift Code</Form.Label>
                <Form.Control
                  name="Swift_code"
                  placeholder="Enter Swift Code"
                  value={formik.values.Swift_code}
                  onChange={formik.handleChange}
                  isInvalid={
                    formik.touched.Swift_code && !!formik.errors.Swift_code
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.Swift_code}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>{" "}
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Swift Bic</Form.Label>
                <Form.Control
                  name="Swift_bic"
                  placeholder="Enter Swift Bic"
                  value={formik.values.Swift_bic}
                  onChange={formik.handleChange}
                  isInvalid={
                    formik.touched.Swift_bic && !!formik.errors.Swift_bic
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.Swift_bic}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>{" "}
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Routing No</Form.Label>
            <Form.Control
              name="Routing_no"
              placeholder="Enter Routing No"
              value={formik.values.Routing_no}
              onChange={formik.handleChange}
              isInvalid={
                formik.touched.Routing_no && !!formik.errors.Routing_no
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.Routing_no}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Currency</Form.Label>
            <Select
              classNamePrefix="form-select"
              placeholder="Select Currency"
              isSearchable={false}
              options={currenciesOptions}
              value={currenciesOptions.find(
                el => el.value === formik.values.currency
              )}
              onChange={({ value }) => formik.setFieldValue("currency", value)}
            />
            {formik.touched.currency && !!formik.errors.currency ? (
              <span className="text-danger mt-2">{formik.errors.currency}</span>
            ) : null}
          </Form.Group>

          <hr />
          <Accordion className="mb-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Show more</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Bank Sort Code ({generalSettings?.prevailingCurrency})
                      </Form.Label>
                      <Form.Control
                        name="bankSortCodeNaira"
                        placeholder={`Enter Bank Sort Code (${
                          generalSettings?.prevailingCurrency
                        })`}
                        value={formik.values.bankSortCodeNaira}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Sort Code (International)</Form.Label>
                      <Form.Control
                        name="bankSortCodeInternational"
                        placeholder="Enter Bank Sort Code (International)"
                        value={formik.values.bankSortCodeInternational}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>{" "}
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Swift Code (International)</Form.Label>
                      <Form.Control
                        name="bankSwiftCodeInternational"
                        placeholder="Enter Bank Swift Code (International)"
                        value={formik.values.bankSwiftCodeInternational}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Swift Address</Form.Label>
                      <Form.Control
                        name="swiftAddress"
                        placeholder="Enter Swift Address"
                        value={formik.values.swiftAddress}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Bank IBAN</Form.Label>
                      <Form.Control
                        name="bankIban"
                        placeholder="Enter Bank IBAN"
                        value={formik.values.bankIban}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>ABA Number</Form.Label>
                      <Form.Control
                        name="abaNumber"
                        placeholder="Enter ABA Number"
                        value={formik.values.abaNumber}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Intermediary Bank</Form.Label>
                      <Form.Control
                        name="intermediaryBank"
                        placeholder="Enter Intermediary Bank"
                        value={formik.values.intermediaryBank}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Corresponding Bank</Form.Label>
                      <Form.Control
                        name="correspondingBank"
                        placeholder="Enter Corresponding  Bank"
                        value={formik.values.correspondingBank}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>{" "}
                </Row>{" "}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Corresponding Bank Account Number</Form.Label>
                      <Form.Control
                        name="correspondingBankAccountNumber"
                        placeholder="Enter Corresponding  Bank  Account Number"
                        value={formik.values.correspondingBankAccountNumber}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>{" "}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Button
            disabled={editBanksMutation.isLoading}
            variant="primary"
            className="w-100 p-2"
            type="submit"
          >
            {editBanksMutation.isLoading ? "Please wait…" : "Save Changes"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
